export default {
  title: 'Bulk Message'
};
